import { useFeatureFlag } from '@bonusly/who-am-i';

/**
 * Whether the People Browser (BIZY-635) should render.
 *
 * Gated behind the `bizy-person-viewer` flag AND the existing
 * `bizy-continuous-chat` flag: the People Browser only makes sense once the
 * single-continuous-conversation refactor is on (it replaces proactive chat
 * messages), so it never renders when continuous chat is off.
 *
 * Single source of truth for the gate so the panel layout, the notification
 * peek repointing, and future People Browser UI all agree.
 */
export function usePeopleBrowserEnabled(): boolean {
	const isContinuous = useFeatureFlag('bizy-continuous-chat');
	const isPersonViewer = useFeatureFlag('bizy-person-viewer');
	return isContinuous && isPersonViewer;
}
